export const ADMIN_PATHS = [
  '/admin-dashboard',
  '/document-manager',
  '/approval-workflow',
  '/acknowledgement-tracking',
  '/rbac',
];

export const isAdminPath = (pathname) =>
  ADMIN_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  );

/** Keep the sidebar order. API path maps are alphabetical, which would open Acknowledgements first. */
export const orderAllowedAdminPaths = (paths) => {
  const allowed = new Set(Array.isArray(paths) ? paths : []);
  const ordered = ADMIN_PATHS.filter((path) => allowed.has(path));
  const extras = [...allowed].filter((path) => !ADMIN_PATHS.includes(path));
  return [...ordered, ...extras];
};
